import { Pagination } from '@mui/material';
import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import { BACKEND_SERVER_URL } from '../../../http/http-config';
import { CiEdit } from 'react-icons/ci';
import { MdDeleteOutline } from 'react-icons/md';
import { showTableResponse, deleteItem, sortInAlphabeticalOrder } from '../common-helpers/commonServices';
import NEET_CombinedTestManagementModal from './NEET_CombinedTestManagementModal';
import NEET_SubjectModal from './NEET_SubjectModal';
import NEET_TestManagementModal from './NEET_TestManagementModal';

const NEET_TestManagement = () => {
    const childRef = useRef();
    const childRef2 = useRef();
    const subjectRef = useRef();
    const [subjects, setSubjects] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [checked, setChecked] = useState([]);
    const [loadSubjects, setSubjectLoading] = useState(false);

    //set Table data
    useEffect(() => {
        axios.get(BACKEND_SERVER_URL + '/neet/subjects').then((res) => {
            const sortedSubjects = sortInAlphabeticalOrder(res.data.subjects, 'Subject');
            setSubjects(sortedSubjects);
            setChecked(sortedSubjects);
        }).catch((error) => {
            console.log(error);
            toast.error(error.response?.data?.message || "An error occurred while fetching subjects.");
        });
    }, [loadSubjects])
    const pageSize = 100;
    const lastIndex = currentPage * pageSize;
    const firstIndex = lastIndex - pageSize;
    const records = checked?.slice(firstIndex, lastIndex);
    const npage = Math.ceil(checked?.length / pageSize)
    const number = [...Array(npage + 1).keys()].slice(1)

    return (
        <>
            <div className="row">
                <div className="col-xl-12">
                    <div className="row">
                        <div className="col-xl-12 wow fadeInUp" data-wow-delay="1.5s">
                             <div className="d-sm-flex text-center justify-content-between align-items-center mb-2">
                                <div className='d-flex align-items-center gap-3'>
                                    <button className='btn btn-dark btn-xs' onClick={() => subjectRef.current.openModal()}>+ Add Subject</button>
                                    <div className='dataTables_info text-dark'>
                                        Records: {checked.length}
                                    </div>
                                </div>
                                {checked.length > pageSize ? <div className="dataTables_paginate paging_simple_numbers justify-content-center  mb-0 pt-2"
                                    id="example-student_wrapper">
                                    <Pagination count={number.length} variant="outlined" color='primary' size="small" page={currentPage} siblingCount={1} boundaryCount={2} onChange={(e, p) => setCurrentPage(parseInt(p))} />
                                </div> : null}
                            </div>
                            <div className="table-responsive full-data" style={{ paddingBottom: "1px", transform: 'rotateX(180deg)' }}>
                                <div id="example-student_wrapper" className="dataTables_wrapper no-footer">
                                    <table className="table-responsive-lg table display dataTablesCard student-tab 
                                    dataTable no-footer mt-0 mb-0" style={{ transform: 'rotateX(180deg)' }} id="example-student" >
                                        <thead style={{ backgroundColor: "#cccccc" }} >
                                            <tr className='text-center  border border-left'>
                                                <th className=' custom-table-header p-2' style={{ width: "50px" }}>Sl.No.</th>
                                                <th className=' custom-table-header p-2 text-start'>SUBJECTS</th>
                                                <th className=' custom-table-header p-2 text-center'>MANAGE QUESTIONS</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {records.length > 0 ? records.map((item, ind) => (
                                                <tr key={ind} className={`${ind % 2 == 1 ? 'custom row-height' : 'row-height'}`} >
                                                    <td className='p-1 text-center' style={{ border: "1px solid #cccccc", width: "50px" }}>
                                                        <h6 className="mb-0 " style={{ fontSize: '12px' }}>
                                                            {firstIndex + ind + 1}
                                                        </h6>
                                                    </td>
                                                    <td className='p-1 text-statt' style={{ border: "1px solid #cccccc" }}>
                                                        <div className="d-flex justify-content-between align-items-center px-2">
                                                            <h6 className="mb-0 ">
                                                                {item.Subject}
                                                            </h6>
                                                            <div className='d-flex align-items-center gap-2'>
                                                                <CiEdit cursor='pointer' size={20} title='Edit Subject' className='text-info' onClick={() => subjectRef.current.openModal(item)} />
                                                                <MdDeleteOutline cursor='pointer' size={20} title='Delete Subject' className='text-danger' onClick={() => deleteItem(item.Sn, 'Subject', '/neet/deleteSubject/', setSubjectLoading, loadSubjects)} />
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="p-1 text-center" style={{ border: "1px solid #ccc", width: "100px" }}>
                                                        <button onClick={() => {
                                                            if (item.Subject == 'Combined') {
                                                                childRef2.current.openModal(item);
                                                            } else {
                                                                childRef.current.openModal(item);
                                                            }
                                                        }} className="btn btn-xs btn-info">Manage</button>
                                                    </td>
                                                </tr>
                                            )) :
                                                <tr>
                                                    <td colSpan="9" className="text-center">
                                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
                                                            {
                                                                showTableResponse(subjects, checked)
                                                            }
                                                        </div>
                                                    </td>
                                                </tr>}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <NEET_TestManagementModal ref={childRef} loadSubjects={loadSubjects} setSubjectLoading={setSubjectLoading} />
            <NEET_CombinedTestManagementModal ref={childRef2} loadSubjects={loadSubjects} setSubjectLoading={setSubjectLoading} />
            <NEET_SubjectModal ref={subjectRef} loadSubjects={loadSubjects} setSubjectLoading={setSubjectLoading} />
        </>
    )
}

export default NEET_TestManagement;
